'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FootballIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 8.79999L8.60005 11.3M12 8.79999L15.4 11.3L14.1 15.3H9.90005L8.60005 11.3M12 8.79999V5.89999M8.60005 11.3L5.80005 10.3M8.80005 3.29999L8.60005 3.89999L12 5.99999L15.4 3.79999L15.2 3.19999M15.4 11.2L18.4 10.2M19.4 6.39999H18.9L18 10.3L21.2001 12.8L21.3 12.7M2.80005 12.8L6.00005 10.4L5.10005 6.39999H4.60005M9.90005 15.2L8.10005 17.7M9.80005 21.2L9.70005 21L8.30005 17.5L4.30005 17.3H4.20005M14.1 15.2L15.8 17.6M19.7001 17.2L15.7 17.4L14.3 21L14.2 21.2M21.2001 12C21.2001 17.1 17.1 21.2 12 21.2C6.90005 21.2 2.80005 17.1 2.80005 12C2.80005 6.89999 6.90005 2.79999 12 2.79999C17.1 2.79999 21.2001 6.89999 21.2001 12Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpFootballIcon = forwardRef(FootballIcon);

export { VpFootballIcon as default };
